import type { PlanDetailsCopy } from '../planDetails'

const tr: PlanDetailsCopy = {
  fieldLabels: {
    current_age: 'Yaşınız',
    retirement_age: 'Emeklilik zamanınız',
    annual_income: 'Yıllık gelir',
    annual_savings: 'Yıllık birikim',
    inflation: 'Enflasyon',
    realization_tax_rate: 'Sermaye kazancı vergisi oranı',
    cost_basis: 'Edinim maliyeti',
    w0: 'Bugünkü yatırılabilir varlıklar',
    primary_residence: 'Oturduğunuz ev',
    total_investable: 'Yatırılabilir varlıklar',
    expected_return: 'Beklenen getiri',
    volatility: 'Oynaklık',
    horizon: 'Planlama ufku',
    jurisdiction: 'Vergi mukimliği',
    risk_aversion: 'Risk toleransı',
    birth_year: 'Doğum yılı',
    birth_date: 'Doğum tarihi',
    marital_status: 'Medeni durum',
    dependents: 'Bakmakla yükümlü olunan kişiler',
    dependent_ages: 'Bakmakla yükümlü olunan kişilerin yaşları',
    children: 'Çocuklar',
    children_birth_years: 'Çocukların doğum yılları',
    partner_age: 'Eşinizin yaşı',
    partner_annual_income: 'Eşinizin yıllık geliri',
    partner_retirement_age: 'Eşinizin emeklilik yaşı',
    plan_to_age: 'Planın sona erdiği yaş',
    gross_annual_income: 'Brüt yıllık gelir',
    net_income: 'Net gelir',
    annual_spending: 'Yıllık harcama',
    essential_spending: 'Zorunlu harcamalar',
    flexible_spending: 'Esnek harcamalar',
    investments_total: 'Toplam yatırım',
    total_investable_wealth: 'Toplam yatırılabilir servet',
    portfolio_mix: 'Portföy dağılımı',
    cgt_rate: 'Sermaye geliri vergi oranı',
    interest_rate: 'Faiz oranı',
    dividend_yield: 'Temettü verimi',
    wealth_tax_rate: 'Servet vergisi oranı',
    filing_jurisdictions: 'Beyanname verilen ülkeler',
    citizenship: 'Vatandaşlık',
    tax_residency: 'Beyan edilen vergi mukimliği',
    state: 'Eyalet veya il',
    region: 'Bölge',
    city: 'Şehir',
    locality: 'Belde',
    church_tax_applicable: 'Kilise vergisine tabi',
    life_cover: 'Hayat sigortası teminatı',
    income_protection: 'Gelir koruma sigortası',
    employer_match: 'İşveren katkısı',
    pension: 'Emeklilik geliri',
    state_pension: 'Devlet emekli aylığı',
    social_security: 'Sosyal güvenlik',
    wage_growth: 'Ücret artışı',
    stability: 'Gelir istikrarı',
    has_will: 'Vasiyetname var mı',
    risk_attitude: 'Riske karşı tutum',
  },
  keyLabels: {
    goal_priority: 'Hedef sıralaması',
    current_age: 'Yaş',
    inflation: 'Enflasyon varsayımı',
    jurisdiction: 'Vergi mukimliği',
    realization_tax_rate: 'Bir hedefi finanse etmek için satışta vergi',
    citizenship: 'Vatandaşlık',
    total_investable: 'Yatırılabilir servet',
    annual_income: 'Yıllık gelir',
    annual_savings: 'Yıllık birikim',
    risk_tier: 'Risk düzeyi',
    retirement_age: 'Emeklilik yaşı',
    target_wealth: 'Hedef servet',
    primary_residence_sellable: 'Evin satışı / daha küçük bir eve geçiş',
  },
  channelLabels: {
    web_levers: 'Sitedeki ayarlar',
    web_cockpit: 'Karar paneli',
    web: 'Web sitesi',
    chat: 'Yapay zekâ asistanı',
    mcp: 'Yapay zekâ asistanı',
    full_review: 'Tam inceleme',
    full_plan: 'Tam plan',
    what_if: 'Senaryo analizi',
  },
  objectiveLabels: {
    status_quo: 'Mevcut durum',
    max_goal_probability: 'En yüksek başarı olasılığı',
    lowest_drawdown: 'En düşük maksimum düşüş',
    highest_growth: 'En yüksek büyüme',
    fastest_to_goal: 'Hedefe en hızlı ulaşma',
  },
  choices: {
    interest_only: 'Yalnızca faiz',
    fixed_rate_amortizing: 'Anapara ödemeli (sabit faiz)',
    variable_rate_amortizing: 'Anapara ödemeli (değişken faiz)',
    repayment: 'Anapara ödemeli',
    refinance: 'Piyasa faiziyle yeniden finanse et',
    repay: 'Tamamen öde',
  },
  values: {
    yearsShort: (n) => `${n} yıl`,
    shareAbout: (pct) => `değerinin yaklaşık ${pct} kadarını`,
    sharePart: 'değerinin bir kısmını',
    aroundAge: (age) => ` yaklaşık ${age} yaşında`,
    inAboutYears: (n) => ` yaklaşık ${n} yıl içinde`,
    maySellFor: (share, when) => `${share}${when} serbest bırakmak için satılabilir; yalnızca bu planı iyileştiriyorsa.`,
    maySell: 'Planı iyileştiriyorsa satılabilir.',
    structuredFact: 'Yapılandırılmış bilgi',
  },
  ask: { talkThrough: 'Bunu MyCIO ile konuşun' },
  review: {
    openInputCheckFailed: 'Eksik bilgi kontrolü tamamlanamadı. Aşağıdaki inceleme durumuna bakın.',
    finishedLoading: 'İncelemeniz tamamlandı. Sonuçlar yükleniyor…',
    draftReady: 'Ön incelemeniz hazır — tamamlanan analiz, hesaplanamayan kısımlar ve bunları tamamlayacak sorular aşağıda.',
    finishedNotLoaded: 'İncelemeniz tamamlandı ancak sonuçları henüz yüklenemedi. Yeniden deneniyor — hesaplama tekrar çalıştırılmayacak.',
    fetchFailed: 'İncelemeniz tamamlandı ancak şu anda alınamadı. Kaydedildi — birazdan tekrar deneyin; yeniden hesaplama gerekmez.',
    notComputed: (list) => `Bu çalıştırmada hesaplanmadı: ${list}.`,
    changesNotSaved: (_n, f) => `${f} değişiklik kaydedilmedi — Bilgileriniz bölümüne bakın.`,
  },
  facts: {
    chooseOption: 'Bir seçenek belirleyin.',
    couldNotSave: 'Bu değer kaydedilemedi. Planınız değişmedi.',
    couldNotUndo: 'Bu değişiklik geri alınamadı.',
    choosePlaceholder: 'Seçin…',
    confirmedBadge: 'Onaylandı — değiştirmek için sohbette isteyin',
    confirmedTitle: (was) => `Bunu daha önce ${was} olarak onayladınız. Değiştirmek için sohbette MyCIO’ya söyleyin.`,
  },
  assumptionsToConfirm: { anInput: 'bir girdi', assumedSuffix: (v) => ` — varsayılan: ${v}` },
  editor: {
    enterNumber: 'Bir sayı girin.',
    enterNumberFor: (l) => `${l} için bir sayı girin.`,
    enterPercentFor: (l) => `${l} için bir yüzde girin.`,
    chooseYesNoFor: (l) => `${l} için Evet veya Hayır seçin.`,
    semicolonBetween: (l) => `${l} öğelerini ";" ile ayırın.`,
    useNumbersFor: (l) => `${l} için sayı kullanın.`,
    wholeNumbersFor: (l) => `${l} için tam sayı kullanın ve ";" ile ayırın.`,
    commaSeparated: 'virgülle ayrılmış',
  },
  freshnessUnknown: 'Kayıtlı hesaplamanızın hesaplarınızdaki son değişiklikleri içerip içermediğini doğrulayamadık. Bu rakamlara güvenmeden önce sayfayı yenileyin ve hesaplarınızı kontrol edin.',
  goals: { goalN: (n) => `Hedef ${n}`, whatMoves: 'bunu ne etkiliyor →', earliest: (y) => `en erken ≈ ${y}`, rank: 'Sıra' },
  issues: {
    mainConstraint: 'Bu planın temel kısıtı',
    riskToReview: 'İncelenecek risk',
    missingInformation: 'Eksik bilgi',
    whyItMatters: (t) => `Neden önemli: ${t}`,
    seeEvidence: 'Destekleyici kanıtları gör ↓',
    noneFound: 'Tamamlanan analiz, bu planda şu anda bulunan bilgilerle önemli bir sorun tespit etmedi.',
    notAvailable: 'Sorun analizi henüz hazır değil. Bu bölümün boş olması, sorun olmadığı anlamına gelmez.',
    discussQuestion: 'Bu planın tespit ettiği sorunları gözden geçirin. Dayanaklarını açıklayın ve durumumla ilgili eksik bir bilginin önceliklerini veya sonuçlarını değiştirip değiştiremeyeceğini sorun.',
    discussLabel: 'Bu sorunları konuşun',
  },
  policies: {
    optionTested: 'Test edilen seçenek',
    computedEffect: (v) => `Hesaplanan etki: ${v}`,
    tradeoff: (v) => `Ödünleşim: ${v}`,
    backToAction: 'Eyleme dön ↑',
    tradeoffsHeading: 'Test edilen durumlardaki ödünleşimler',
  },
  transfer: {
    toHeirs: (m) => `mirasçılara +${m}`,
    fundedPoints: (label, pts) => `${label} ${pts} yüzde puan`,
    noChange: ' · hedeflerinizin finansmanında değişiklik yok',
  },
  tax: {
    rulesIntro: 'Yalnızca bu hesaplamaya bağlı kurallar gösterilir. Her kayıtta kaydedilen kaynak bilgileri yer alır; eksik tarihler veya kapsam bilgileri eksik olarak açıkça gösterilir.',
    title: 'Bu planda kullanılan vergi uygulaması',
    countryBookPrimary: 'Projeksiyon, ilgili ülkenin vergi mevzuatını yıl yıl uyguladı. Açıkça resmî veya birincil olarak kaydedilen kaynaklar aşağıda listelenmiştir.',
    countryBookNoPrimary: 'Projeksiyon, ilgili ülkenin vergi mevzuatını yıl yıl uyguladı. Bu kayıtlı sonuca henüz birincil kaynak bağlantıları eklenmedi; bu nedenle vergiye duyarlı kararları uygulamadan önce doğrulayın.',
    simplified: 'Hesaplamada basitleştirilmiş bir vergi uygulaması kullanıldı. Vergiye duyarlı karşılaştırmalara güvenmeden önce aşağıdaki sınırlamaları inceleyin.',
    askQuestion: 'Bu plana hangi vergi yasalarının ve ülke katmanlarının uygulandığını, hangilerinin yaklaşık alındığını veya dışarıda bırakıldığını ve vergi durumumla ilgili hangi bilgilerin sonucu değiştirebileceğini açıklayın. Yalnızca bu hesaplamaya gerçekten eklenmiş birincil kaynakları kullanın ve eksik kaynakları belirtin.',
    askLabel: 'Vergi uygulaması hakkında sorun',
  },
  inputs: { title: 'Sonucu değiştirebilecek girdiler', infoToConfirm: 'Onaylanacak bilgi' },
  gated: {
    countChoices: (_n, f) => `sizin için hesapladığımız ${f} seçenek`,
    mappedYears: (_n, f) => `önümüzdeki ${f} yılı haritaladık`,
    extraChecks: (_n, f) => `planınızı ${f} ek yöntemle kontrol ettik`,
    placeholderRows: ['Örnek satır', 'Örnek rakam', 'Örnek seçenek', 'Yer tutucu'],
  },
}

export default tr
